import React from 'react';

/**
 * Useful message formatting for text appearing within BigNumberBox.
 *
 * @type {{bigger: (function(*): *), 'bigger-negative': (function(*): *)}}
 */
export default {
    /* eslint-disable react/jsx-one-expression-per-line */

    bigger: str => <span className="rh-font-size-3xl">{str}</span>,
    'bigger-negative': str => <span className="rh-font-size-3xl rh-fg-strawberry">{str}</span>,

    /* eslint-enable react/jsx-one-expression-per-line */
};
